import { useState } from "react";
import { CommonDialog } from 'components';
import {
  Container,
  TextField,
  Button,
  Typography,
  Paper,
  InputAdornment,
  ClickAwayListener,
} from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import { toast, blobToFileDownload, base64ToFileDownload, b64toBlob } from 'utils/helpers';
import api from 'utils/api';
import { FormField2 as Field } from 'components';


const AggregateRateExportModal = ({ objectId, onClose, estimateTitle, validRowTypes }) => {
  const [groupingType, setGroupingType] = useState("estimate");
  const [type, setType] = useState("rate");
  const [isCreating, setIsCreating] = useState(false);
  const { t } = useTranslation();

  const downloadFile = (name, base64Data) => {
    const blob = b64toBlob(base64Data, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');

    blobToFileDownload(name, blob);
  }

  const handleExport = async () => {
    try {
      const response = api.get(`/estimates/${objectId}/export-aggregated-${type === "rate" ? "rates" : "resources"}`, {
        params: { groupingType },
      });
      setTimeout(() => {
        window.dispatchEvent(new Event('fetchAndOpenNotifications'));
      }, 500);
      onClose();
    } catch (err) {
      console.error(err);
      toast(type === "rate" ? t(`Klaida eksportuojant sustambintus įkainius`) : t(`Klaida eksportuojant sustambintus resursus`), "error");
    }
  }

  const handleCreateEstimate = async () => {
    try {
      setIsCreating(true);
      const response = api.post(`/estimates/${objectId}/export-aggregated-to-estimate`, {
        groupingType,
        type,
      });

      onClose();
      setTimeout(() => {
        window.dispatchEvent(new Event('fetchAndOpenNotifications'));
      }, 500);
    } catch (err) {
      console.error(err);
      toast(t("Klaida kuriant naują sąmatą"), "error");
    } finally {
      setIsCreating(false);
    }
  };

  const getTypeOptions = () => {
    const options = [];
    if (validRowTypes.includes("estimate")) options.push({ value: "estimate", label: t("Sąmata") });
    if (validRowTypes.includes("part")) options.push({ value: "part", label: t("Sąmatos dalis") });
    if (validRowTypes.includes("chapter")) options.push({ value: "chapter", label: t("Skyrius") });
    if (validRowTypes.includes("subchapter")) options.push({ value: "subchapter", label: t("Poskyris") });
    return options;
  };

  return (
    <CommonDialog
      visible
      actions={[
        <>
          <Button
            variant="contained"
            color="primary"
            onClick={() => onClose()}
            disabled={isCreating}
          >
            {t("Uždaryti")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCreateEstimate}
            disabled={isCreating}
            style={{ marginLeft: 8 }}
          >
            {t("Formuoti naują sąmatą")}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleExport}
            disabled={isCreating}
            style={{ marginLeft: 8 }}
          >
            {t("Formuoti Excel")}
          </Button>
        </>
      ]}
    >
      <Container maxWidth="sm" onClickOutside={() => onClose()}>
        <Typography variant="h6" gutterBottom style={{ fontWeight: 600 }}>
          {type === "rate" ? t("Pasirinkite grupavimo tipą sustambintų įkainių formavimui") : t("Pasirinkite grupavimo tipą sustambintų resursų formavimui")}
        </Typography>
        <div>
          <Field
            name="groupingType"
            label={t("Grupavimo tipas")}
            type="select"
            value={groupingType}
            onChange={(e) => setGroupingType(e.value)}
            options={() => getTypeOptions()}
          />
          <Field
            name="aggregateRateExport"
            type="radio"
            label={t("Formuoti sumines kainas")}
            onChange={() => setType("rate")}
            value={type == "rate"}
          />
          <Field
            name="aggregateResourceExport"
            type="radio"
            label={t("Formuoti sustambintus įkainius su resursais")}
            onChange={() => setType("resource")}
            value={type == "resource"}
          />
        </div>
      </Container>
    </CommonDialog>
  );
};

export default AggregateRateExportModal;